import React from 'react';
import {
    CleanIcon,
    IconCubeInMotion,
    IconMaterialType, ImgCheckInHeader
} from "../../../../components/buttons/IconButtons";
import {MaterialRecordDeliveryModalApp} from "../Functionality/MaterialRecordDeliveryModalApp";
import {CustomTextField} from "../../../../components/CustomTextField";
import CustomChip from "../../../../components/CustomChip";
import {colors} from "../../../../enums/colors";
import CustomModal from "../../../../components/Modal/CustomModal";
import CustomCard from "../../../../components/CustomCard";
import CustomPhotoPicker from "../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import {
    PHOTO_PICKER_MODEL,
    SUGGESTION_MODE_OPTION
} from "../../../../components/PhotoPicker/SubComponent/Models/Models";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {getUnitTransByName} from "../../Dining/Ingredients/Model/Models";
import CustomTooltip from "../../../../components/CustomTooltip";
import {size5MB} from "../../../../constant/variable";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const MaterialRecordDeliveryModal = (props) => {
    const { onHide, itemSelected, setModified, show } = props;

    const {
        t,
        data,
        handleChange,
        photoPicker,
        setPhotoPicker,
        displayModal,
        setDisplayModal,
        clear,
        setClear,
        emptyFields,
        onConfirm,
        handleClearFields
    } = MaterialRecordDeliveryModalApp({
        onHide,
        itemSelected,
        setModified
    });

    return (
        <CustomModal
            show={show}
            size='lg'
            buttonConfirm='confirm'
            onHide={() => {
                handleClearFields();
                onHide();
            }}
            confirmButton={true}
            cancelButton={true}
            display={displayModal}
            onConfirm={onConfirm}
            topLeftHeader={
                <>
                    <div className={"d-flex align-items-center"}>
                        <div className={"mr-2"}>
                            <IconCubeInMotion/>
                        </div>
                        <div className={"flex-grow-1 minw-0"}>
                            <CustomTooltip
                                text={itemSelected?.name}
                                classes={"font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                showIfTruncated={true}
                                placement={"top"}
                            />
                        </div>
                        <div className="vertical-separator-shades-950 h-auto" />
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={`${itemSelected?.quantity} ${t(getUnitTransByName(itemSelected.measurementUnitName))}`}
                            icon={<IconMaterialType width={14} height={14} />}
                            className='icon-color-secondary-700'
                        />
                    </div>
                </>
            }
        >
            <CustomCard classCard={"card-border-8px"} classContent={"p-0"}>
                <ImgCheckInHeader className={"w-100"}/>
                <div className={"row"}>
                    { !data?.id &&
                        <div className="col-12 d-flex justify-content-end pt-4">
                            <ButtonIcon
                                id='btn_mrd_clean_fields'
                                Icon={CleanIcon}
                                onClick={handleClearFields}
                                title={'clear_instances'}
                                className={"btn-clean-secondary-600"}
                                iconProps='btn-icon-svg-12px icon-color-general-00'
                            />
                        </div>
                    }

                    <div className={'col-12 pt-4'}>
                        <p className="text-center ibl-font-w-700 text-uppercase">
                            {t('please_provide_any_relevant_observations_regarding_material_dispatch_below')}
                        </p>
                    </div>
                    <div className='col-12 pt-4'>
                        <CustomTextField
                            id="txt_mdm_note"
                            length={512}
                            name="note"
                            value={data?.note}
                            trans="dispatch_note"
                            type="text"
                            onChange={handleChange}
                            multiline={true}
                            required={true}
                            emptyFields={emptyFields}
                        />
                    </div>

                    <div className='col-12 mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>
                            {t('attach_evidence_required')}
                        </p>
                    </div>

                    <div className='col-12'>
                        <CustomPhotoPicker
                            id='fp_mrd_photo_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE, size: size5MB }}
                            showBtnDelete={true}
                            required={true}
                            disabled={false}
                            showBtnCamera={true}
                            validateFace={false}
                            classWith={'w-100'}
                            showPreview={photoPicker.id !== null }
                            typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                            setDisplayModal={setDisplayModal}
                            clear={clear}
                            setClear={setClear}
                            inputContainerClass={'h-auto'}
                            emptyFields={emptyFields}
                            handleDelete={() => {
                                setPhotoPicker({...PHOTO_PICKER_MODEL, id: null});
                            }}
                        />
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default MaterialRecordDeliveryModal;
